export const NAVIGATION_MENUS = [
  {
    name: 'projects',
    key: 'projects',
    path: '/projects',
  },
  {
    name: 'publication & Tools',
    key: 'publications',
    path: '/publications',
  },
  {
    name: 'data',
    key: 'data',
    path: '/report-data',
  },
  {
    name: 'learners',
    key: 'learners',
    path: '/learners',
  },
  // {
  //   name: 'Showcase',
  //   key: 'showcase',
  //   path: '/showcase-revamp',
  // },
  {
    name: 'AI Playground',
    key: 'ai-playground',
    path: '/ai-playground',
  },
];

export const CONTENT_TYPE = [
  {
    labelKey: 'content.assessment',
    type: 'assessment',
  },
  {
    labelKey: 'content.collection',
    type: 'collection',
  },
  {
    labelKey: 'content.resource',
    type: 'resource',
  },
  {
    labelKey: 'content.offline.activity',
    type: 'offline-activity',
  },
  {
    labelKey: 'content.course',
    type: 'course',
  },
  {
    labelKey: 'content.question',
    type: 'question',
  },
];



export const DEFAULT_IMAGES_PATH: any = {
  profile: '/img/default-images/profile.png',
  partner: '/img/default-images/partner.png',
  collection: '/img/default-images/collection-default.png',
  assessment: '/img/default-images/assessment-default.png',
  marker: '/img/student-marker.png',
};

// Competency status
export const COMPETENCY_STATUS = [
  'Not Started',
  'In Progress',
  'Mastered (Inferred)',
  'Mastered (Asserted)',
  'Mastered (Earned)',
  'Mastered (Demonstrated)',
];

export const LEARNING_MAP_CONTENT_TYPE = [
  {
    labelKey: 'assessment',
    type: 'assessment',
  },
  {
    labelKey: 'collection',
    type: 'collection',
  },
  {
    labelKey: 'resource',
    type: 'resource',
  },
  {
    labelKey: 'offline activity',
    type: 'offline-activity',
  },
  {
    labelKey: 'course',
    type: 'course',
  },
  {
    labelKey: 'question',
    type: 'question',
  },
  {
    labelKey: 'lesson',
    type: 'lesson',
  },
  {
    labelKey: 'unit',
    type: 'unit',
  },
  {
    labelKey: 'rubric',
    type: 'rubric',
  },
];

export const GRADING_SCALE = [{
  LOWER_LIMIT: 0,
  COLOR: '#F46360',
  RANGE: '0-59',
},
{
  LOWER_LIMIT: 60,
  COLOR: '#ED8E36',
  RANGE: '60-69',
},
{
  LOWER_LIMIT: 70,
  COLOR: '#FABA36',
  RANGE: '70-79',
},
{
  LOWER_LIMIT: 80,
  COLOR: '#A8C99C',
  RANGE: '80-89',
},
{
  LOWER_LIMIT: 90,
  COLOR: '#4B9740',
  RANGE: '90-100',
},
];

export const LEARNER_PREFERENCE_META: any = {
  video: {
    labelKey: 'Video Resources',
    icon: 'video-resource',
  },
  webpage: {
    labelKey: 'Web Based Resources',
    icon: 'website-resource',
  },
  interactive: {
    labelKey: 'Interactive Resources',
    icon: 'interactive-resource',
  },
  image: {
    labelKey: 'Image Resources',
    icon: 'image-resource',
  },
  text: {
    labelKey: 'Text Resources',
    icon: 'text-resource',
  },
  audio: {
    labelKey: 'Audio Resources',
    icon: 'audio-resource',
  },
  project: {
    labelKey: 'Project',
    icon: 'offline-activity-gray',
  },
};


export const GOORU_DEFAULT_STANDARD = 'GDF';

export const GOORU_DEFAULT_FRAMEWORK = 'GDT';

export const MICRO_COMPETENCY_CODE_TYPES = [
  'learning_target_level_0',
  'learning_target_level_1',
  'learning_target_level_2',
];

export const TAXONOMY_LEVELS = {
  COURSE: 'course',
  DOMAIN: 'domain',
  STANDARD: 'standard',
  MICRO: 'micro-standard',
};

export const LEARNER_MINDSETS_VECTORS = [
  'grit',
  'perseverance',
  'motivation',
  'selfConfidence',
];

export const LEARNER_COMMUNITY_VECTORS = [
  'citizenship',
  'authority',
  'reputation',

];
export const DEMO_USERS = [
  'e062559a-35d2-45e9-85fd-380987dc2fdf',
];

export const PERMISSION_LIST = {
  learnersView: 'learners-view',
  learnerIdentity: 'learners-identity',
  all: 'all',
  roleView: 'role-view',
};

export const ROLE_MENUS = {
  research: 'research',
  projects: 'projects',
  data: 'data',
  learners: 'learners',
  publications: 'publications',
  nav: 'nav',
  all: 'all',
  showcase: 'showcase',
};

export const FACETS_DEFAULT_FILTER: any = [
  'e8a409f5-7fd9-4027-8955-3eda9322413f',
];

export const AI_PLAYGROUND_LEARNER = 'e8a409f5-7fd9-4027-8955-3eda9322413f';

export const SHOWCASE_DEMO_ACCOUNT = 'cHNfZGVtb19hZG1pbkBnb29ydS5vcmc6Z29vcnUxMjM=';


export const VECTOR_VALUES = [
  {
    label: 'grit',
    value: 0.5,
  },
  {
    label: 'perseverance',
    value: 0.4,
  },
  {
    label: 'motivation',
    value: 0.8,
  },
  {
    label: 'selfConfidence',
    value: 0.6,
  },
  {
    label: 'citizenship',
    value: 0.5,
  },
  {
    label: 'authority',
    value: 0.8,
  },
  {
    label: 'reputation',
    value: 0.4,
  },
];

export const TEMP_CONST_LEARNER = ['e8a409f5-7fd9-4027-8955-3eda9322413f'];

export const DEFAULT_CATALOG_STRING: any = {
  resource: {
    audio_resource: { name: 'Audio', colorCode: '#377eae' },
    video_resource: { name: 'Videos', colorCode: '#429aa9' },
    interactive_resource: { name: 'Interactive', colorCode: '#59b3a1' },
    image_resource: { name: 'Images', colorCode: '#78c69c' },
    webpage_resource: { name: 'Webpages', colorCode: '#99d59a' },
    text_resource: { name: 'Text', colorCode: '#b8e297' },
  },
  question: {
    multiple_choice_question: { name: 'Multiple Choice', colorCode: '#377eae' },
    multiple_answer_question: { name: 'Multiple Answer', colorCode: '#429aa9' },
    true_false_question: { name: 'True Or False', colorCode: '#59b3a1' },
    fill_in_the_blank_question: { name: 'Fill In The Blank', colorCode: '#78c69c' },
    hot_spot_image_question: { name: 'Multiple Select - Image', colorCode: '#99d59a' },
    hot_spot_text_question: { name: 'Multiple Select - Text', colorCode: '#b8e297' },
    hot_text_highlight_question: { name: 'Highlight Text', colorCode: '#d4ed96' },
    hot_text_reorder_question: { name: 'Drag And Drop Order', colorCode: '#e9f69d' },
    open_ended_question: { name: 'Open Ended', colorCode: '#f6f9a7' },
  },
};

export const MARKER_TYPES: any = {
  txImplicitMarker: 'Implicit Marker',
  txExplicitMarker: 'Explicit Marker',
};

export const CENTURY_SKILLS_GROUPS = {
  KEY_COGNITIVE_SKILLS_AND_STRATEGIES: 'Key Cognitive Skills and Strategies',
  KEY_CONTENT_KNOWLEDGE: 'Key Content Knowledge',
  KEY_LEARNING_SKILLS_AND_TECHNIQUES: 'Key Learning Skills and Techniques',
};

export const EXTRACTED = ['title', 'description', 'format'];
export const CURATED = [
  'Published By',
  'Publish Status',
  'Modified by',
  'Created by',
  'Aggregator',
  'Date Modified',
  'License',
  'language',
  'educational use',
  'accessbility',
  'grade',
  'age-range',
  'Editorial Range',
  'Audience',
  'Time Required',
  'media Features',
  'Grade Level',
  'access hazard',
  'advertisement level',
  'Learning Objective',
  'Keywords',
  'framebreaker',
  'Visibility',
];
export const TAGEED = [
  'Instructional Model',
  '21st Century Skills',
  'subject',
  'course',
  'domain',
  'audience',
  'standard',
  'Depth of Knowledge',
  'Reading Level',
];
export const COMPUTED = [
  'Publisher',
  'relevance',
  'engagement',
  'efficacy',
  'summary',
  'transcript',
  'address',
  'created by',
  'created on',
  'modified on',
  'modified by',
];

export const PORTFOLIO_CONTENT_TYPES = [
  {
    name: 'Assessment(s)',
    key: 'assessment',
  },
  {
    name: 'Collection(s)',
    key: 'collection',
  },
  {
    name: 'Offline Activity(s)',
    key: 'offline-activity',
  },
];

export const SOURCE_KEYS_AND_VALUES: any = {
  'lpbaseline-to-lpcs-migration': '',
  'initialSkylineGenerated': 'Student has demonstrated mastery in the competency after taking a diagnostic',
  'diagnostic': 'Student has demonstrated mastery in the competency after taking a diagnostic',
  'topic-based-lpcs-migration': '',
  'topic-based-lpcs-migration-lusd': '',
  'NWEA': `Student's mastery in the competency has been determined based on a standardized test scores (NWEA MAP)`,
  'NWEA-Asserted': `Student's mastery in the competency has been determined based on a standardized test scores (NWEA MAP)`,
  'ForceCalculateTrigger': `Student's mastery in the competency has been determined based on assertion`,
  'coursemap': '',
  'ILActivity': '',
  'dailyclassactivity': '',
  'Teacher-Asserted': '',
  'competencyMastery': '',
  'OfflineClassTrigger': '',
};

export const ROUTE_MAP_ICONS = {
  startPoint: '/img/map-icon.svg',
  destination: '/img/map-pointer.svg',
};

export const COMPETENCY_REPORT_FREQUENCY = [
  {
    frequency: 'daily',
    label: 'Day',
  },
  {
    frequency: 'weekly',
    label: 'Week',
  },
  {
    frequency: 'monthly',
    label: 'Month',
  },
];

export const ECPA_RULES = [
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is below the minimum mastery threshold score, there is only one attempt, no struggle is present, mastery level is less than 4, and the learner is a struggling learner.',
    rule_id: 'ACRule01',
    principle_of_earning: '(P1) Build on foundational knowledge',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is below the minimum mastery threshold score, there is only one attempt, no struggle is present, mastery level is less than 4, and the learner is a strong learner.',
    rule_id: 'ACRule03',
    principle_of_earning: '(P3) Revisit multiple times in new contexts',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is below the minimum mastery threshold score, there is only one attempt, no struggle is present, mastery level is greater than or equal to 4, and the learner is a strong learner.',
    rule_id: 'ACRule07',
    principle_of_earning: '(P3) Revisit multiple times in new contexts (P11) Choice, within reasonable limits and with supports, fosters engagement, confidence-building, and perseverance',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is below the minimum mastery threshold score, there are two attempts, no struggle is present, mastery level is greater than or equal to 4, and the learner is a struggling learner.',
    rule_id: 'ACRule10',
    principle_of_earning: '(P11) Choice, within reasonable limits and with supports, fosters engagement, confidence-building, and perseverance',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is below the minimum mastery threshold score, there are two attempts, no struggle is present, mastery level is greater than or equal to 4, and the learner is a struggling learner.',
    rule_id: 'ACRule12',
    principle_of_earning: '(P11) Choice, within reasonable limits and with supports, fosters engagement, confidence-building, and perseverance',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is above the minimum mastery threshold score, there is only one attempt, no struggle is present, mastery level is less than 4, and the learner is a struggling learner.',
    rule_id: 'ACRule13',
    principle_of_earning: '(P1) Build on foundational knowledge',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is above the minimum mastery threshold score, there is only one attempt, no struggle is present, mastery level is less than 4, and the learner is a strong learner.',
    rule_id: 'ACRule15',
    principle_of_earning: '(P8) Frequent embedded assessment, multiple levels of challenge and multiple kinds of evidence',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is above the minimum mastery threshold score, there are two attempts, no struggle is present, mastery level is less than 4, and the learner is a strong learner.',
    rule_id: 'ACRule16',
    principle_of_earning: '(P1) Build on foundational knowledge (P8) Frequent embedded assessment, multiple levels of challenge and multiple kinds of evidence',
  },
  {
    rule_desc: 'This rule represents a set of conditions that evaluate to true if the score is above the minimum mastery threshold score, there are two attempts, no struggle is present, mastery level is less than 4, and the learner is a strong learner.',
    rule_id: 'ACRule18',
    principle_of_earning: '(P8) Frequent embedded assessment, multiple levels of challenge and multiple kinds of evidence',
  },
];
